import { differenceInDays, differenceInHours, differenceInMinutes } from 'date-fns';
import { useNow } from '../common/hooks/use-now';

export function useTimeSince(date: Date) {
    const now = useNow();

    const days = differenceInDays(now, date);
    const hours = differenceInHours(now, date) % 24;
    const minutes = differenceInMinutes(now, date) % 60;

    if (days >= 10) {
        return `${days}D`;
    }

    const parts = [];
    if (days > 0) {
        parts.push(`${days}D`);
    }

    if (hours > 0) {
        parts.push(`${hours}H`);
    }

    if (minutes > 0) {
        parts.push(`${minutes}M`);
    }

    if (parts.length === 0) {
        return '0M';
    }

    return parts.join(' ');
}
